import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/app/store";

interface ViewGeneralSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const formatDuration = (seconds: number) => {
  const hours = seconds / 3600;
  return `${hours} hrs`;
};

const ViewGeneralSettingsModal: React.FC<ViewGeneralSettingsModalProps> = ({
  isOpen,
  onClose,
}) => {
  const data = useSelector((state: RootState) => state.settings.general); // Assuming settings.general holds the data


  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-2xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">General Settings</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-red-600 text-2xl"
          >
            &times;
          </button>
        </div>

        <div className="space-y-2 text-sm text-gray-700">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <strong>ID:</strong> {data.id}
            </div>
            <div>
              <strong>Status:</strong> {data.status}
            </div>
            <div>
              <strong>Payment Duration:</strong>{" "}
              {formatDuration(data.paymentDuration)}
            </div>
            <div>
              <strong>Dispute Appeal Duration:</strong>{" "}
              {formatDuration(data.disputeAppealDuration)}
            </div>
            <div>
              <strong>Accept Initial Order Duration:</strong>{" "}
              {formatDuration(data.acceptInitialOrderDuration)}
            </div>
            <div>
              <strong>Accept Order Duration:</strong>{" "}
              {formatDuration(data.acceptOrderDuration)}
            </div>
            <div>
              <strong>Request Return Duration:</strong>{" "}
              {formatDuration(data.requestReturnDuration)}
            </div>
            <div>
              <strong>Dispatch Waiting Duration:</strong>{" "}
              {formatDuration(data.dispatchOrderWaitingDuration)}
            </div>
            <div>
              <strong>Default Payment Provider:</strong>{" "}
              {data.defaultPaymentProvider}
            </div>
            <div>
              <strong>Created At:</strong>{" "}
              {new Date(data.createdAt).toLocaleString()}
            </div>
            <div>
              <strong>Updated At:</strong>{" "}
              {new Date(data.updatedAt).toLocaleString()}
            </div>
          </div>
        </div>

        <div className="mt-6 text-right">
          <button
            onClick={onClose}
            className="bg-primary text-white px-4 py-2 rounded-full hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewGeneralSettingsModal;
